<template>
  <div class="value-widget">
    <b-row>
      <b-col v-for="tz in options.timezones" :key="tz.name">
        <h5 class="text-center"><strong>{{ (tz.name || 'local') }}:</strong><br />{{ time.setZone((tz.tz || 'local')).toFormat('DD') }}<br />{{ time.setZone((tz.tz || 'local')).toFormat('TT') }}</h5>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { DateTime } from 'luxon'

export default {
  name: 'Clock',
  props: ["options"],

  mounted() {
    setInterval(function() {
      this.time = DateTime.local()
    }.bind(this), 500)
  },

  data() {
    return {
      time: DateTime.local()
    }
  }
}
</script>
